<app-material>
    <div class="header" header>
        <h2>{{ 'admin.tools.details.interventionsPage.table.title' | translate }}</h2>
        <app-button
            type="primary"
            (click)="onDownloadExcelFile()">
            {{ 'reportDownloadForm.downloadButton' | translate }}
        </app-button>
    </div>
    <ng-container body>
        <app-interventions-table [interventions]="selectedTool?.interventions"
                                 [isLoading]="isLoading"
                                 [isMaterial]="false"
                                 [hasTitle]="false"
                                 [canOpenTicketDetails]="canOpenTicketDetails()"
                                 [tableConfig]="tableConfig"
                                 [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                                 (sortChange)="onSortChange($event)"
                                 (filterChange)="onFilter($event)"
                                 (pageChange)="onPageChange($event)"
                                 (rowClick)="onTableRowClick($event)">
        </app-interventions-table>
    </ng-container>
</app-material>
